import CookieConsentAcceptButton from "src/Candidate/atoms/CookieConsentAcceptButton";
import CookieConsentDeclineButton from "src/Candidate/atoms/CookieConsentDeclineButton";
import CookieConsentTitle from "src/Candidate/atoms/CookieConsentTitle";
import CookieConsentDescription from "src/Candidate/atoms/CookieConsentDescription";
import styles from "./CookieConsent.module.css";

type CookieConsentProps = {
  onResponse?: () => void;
};

export default function CookieConsent(props: CookieConsentProps): JSX.Element {
  const { onResponse } = props;
  return (
    <div className={styles.modal}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <CookieConsentTitle />
          <CookieConsentDescription />
        </div>
        <div
          className={styles.actions}
          role="button"
          tabIndex={0}
          onKeyDown={onResponse}
          onClick={onResponse}
        >
          <CookieConsentAcceptButton />
          <CookieConsentDeclineButton />
        </div>
      </div>
    </div>
  );
}
